import React, {useState} from 'react';
import {Link} from "react-router-dom";
import DomainTablePage from '../../components/domainTablePage.js'
import VersionDistributionChart, {Version as DistributionCharVersion} from '../../components/versionDistributionChart.js'
import useGoogleCharts from '../../components/useGoogleCharts.js';
import CopyLink from '../../components/copyLink.js'
import UserError from '../../components/userError.js';
import {
	_printNumber
	} from '../../helpers/helpers'

import {TechnologyVersionWebsitesPageResult} from '../../../../server/routes/technology.js'

interface TechnologyVersionWebsitesProps {
	server: string;
	pageData: unknown;
}

interface ComponentProps {
	props: TechnologyVersionWebsitesPageResult;
}

function _createCVEVulnerabilityError(data: TechnologyVersionWebsitesPageResult): string | undefined {

    if (!data.CVEs || !data.CVEs.length) 
		return undefined;

	let cve = '';
	data.CVEs.forEach((c) => {
		if (cve.length > 0) cve += ', ';
		cve += `<a class="link-hover" href="/cve/${c.CVEId}"><b>${c.CVEId}</b></a>`;
	})

	// data.Warning = `${data.PageKeywords} is vulnerable to ${cve}`;		
	return (`${data.PageKeywords} is vulnerable to ${cve}`);
}

export default function TechnologyVersionWebsites({server, pageData}: TechnologyVersionWebsitesProps) {

	const typedPageData = pageData as TechnologyVersionWebsitesPageResult;
	let [data, setData] = useState(typedPageData);
	// let [warning, setWarning] = useState<string | undefined>(_createCVEVulnerabilityError(data));

	const google = useGoogleCharts();

	const versionsForDistributionChart = 
		data.TechnologyVersions.map((version) => {
			const outVersion: DistributionCharVersion = {
				...version,
				Highlight: version.Version === data.Version
			}
			return outVersion;
		})

	return (
        <>

			<section className="section section-sm">
				<div className="container">
					<div className="row row-50">                        
                        <div className="col-md-12 col-lg-8 col-xl-12">
                        <h3 style={{wordWrap: 'break-word'}}>{data.PageKeywords}</h3>                    
                        <TechnologyVersionBrag props={data} />	
                        <UserError message={_createCVEVulnerabilityError(data)}/>		
                        </div>
					</div>	
					{!!data.TechnologyDomains.DomainCount	&&
						<>		
							{
								!!versionsForDistributionChart.length &&	                	
								<div className="row row-50">  					
									<div className="col-md-12 col-lg-8 col-xl-12">
									<h3>All versions</h3>
									Version {data.Version} is highlighted in green
									<VersionDistributionChart versions={versionsForDistributionChart} google={google}/>		
									</div>
								</div>
							}	
							<div className="row row-50"> 					
								<div className="col-md-12 col-lg-12 col-xl-12">
									<DomainTablePage 
										domainList={data.TechnologyDomains}
									/>				
								</div>					
							</div>
						</>
					}
				</div>
			</section>
        </>
	)
}

/*
function UserError({message}) {

	if (!message) {
		return null;
	}

	return (
		<><br />
			<div className="alert alert-warning alert-dismissible fade show" role="alert">
				<div dangerouslySetInnerHTML={{__html: message}}/>
				<button type="button" className="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			</>
		)
}
*/

// function TechnologyVersionUsageStats({props}: ComponentProps) {

// 	return (
// 		<>
// 			<div className="row row-50">
// 			<div className="col-12">
// 				<h3 className="text-left" id="stats">Technology usage statistics				
// 				<CopyLink link={props.CanonicalURL}  anchor='stats'/> 
// 				</h3>
// 				<table className="table-custom table-custom-striped table-custom-primary">
// 					<tbody>
// 						<tr>
// 							<td>Websites using {props.TechnologyShortName}</td>
// 							<td>
// 								<span className="icon text-primary">
//                                 <b>{_printNumber(props.TechnologyDomains.DomainCount)}</b>
//                                     {/**
// 									<Link 
// 										to={`/technology/${props.TechnologyURL}/websites`}
// 										className="link-hover" 
// 										title={`List of websites that are using ${props.TechnologyShortName} technology`} 
// 									>
// 										<b>{_printNumber(props.TechnologyUsage.DomainCount)}</b> websites
// 									</Link>                                     * 
//                                      * 
//                                      */

//                                     }

// 								</span>
// 							</td>
// 						</tr>
// 					</tbody>
// 				</table>
// 			</div>
// 		</div>
// 	</>
// 	)
// }

function TechnologyVersionBrag({props}: ComponentProps) {

	return (
		<>
			<p>
                We have identified&nbsp;
				<span className="icon text-primary">
                <b>{_printNumber(props.TechnologyDomains.DomainCount)}</b>
                </span> live websites utilizing     {props.PageKeywords}.
			</p>
			<br />
		</>
	)
}